import { render } from "./PortfolioDetails.vue?vue&type=template&id=1294a6e0"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js"
script.render = render

export default script